import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import "./styles.css";

const Login = ({ onLogin, isAuthenticating }) => {
  if (isAuthenticating) {
    return (
      <Box className="login-box">
        <div className="login-container">
          <p className="popup-description" id="popup-description">
            GM Energy Home Hardware Installation
          </p>
          <p className="popup-message">
            Authenticating, please wait&hellip;
          </p>
          <div className="login-button">
            <CircularProgress size={32} sx={{ color: "#000" }} />
          </div>
        </div>
      </Box>
    );
  }

  return (
    <Box className="login-box">
      <div className="login-container">
        <p className="popup-description" id="popup-description">
          GM Energy Home Hardware Installation
        </p>
        <p className="popup-message" id="popip-message">
          Please log in or sign up to gain access to install or perform
          maintenance on GM Energy home hardware.
        </p>
        <div className="login-button">
          <Button
            variant="contained"
            color="primary"
            onClick={onLogin}
            sx={{
              backgroundColor: "#000",
              "&:hover": { backgroundColor: "#0009FF" },
            }}
          >
            Log in / Sign up
          </Button>
        </div>
      </div>
    </Box>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
  isAuthenticating: PropTypes.bool,
};

export default Login;
